import { DateUtil } from '@/utils';
import mutations from './accKeyExceptionMutation';
import actions from './accKeyExceptionAction';
import getters from './accKeyExceptionGetter';

const state = {
  cnt: 0,
  gridData: {},
  searchParam: {
    divisionCode: '', // 사업부
    cspCode: '', // CSP
    accoutId: '', // Linked Account
    projectName: '', // 프로젝트 명
    keyAge: '', // Key Age
    keyAgeComparison: '', // Key Age 비교 연산자
    batchDate: null, // 조회일자
    keyExcept: '', // 보안조치
    ipRestriction: '', // IP접근제어 여부
    keyMaintain: '' // 유지 여부
  },
  item: {},
  projectList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
  DateUtil,
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/exception/accKeyExceptionStore.js